class SocialProofTicker extends HTMLElement {
  constructor() {
    super();
    this.marquee = this.querySelector('[data-spt-marquee]');
    this.track = this.querySelector('[data-spt-track]');
    this.liveNum = this.querySelector('[data-live-num]');
    this.initMarquee();
    this.initLiveCounter();
  }

  initMarquee() {
    if (!this.marquee || !this.track) return;
    
    const clone = this.track.cloneNode(true);
    clone.setAttribute('data-spt-track-clone', '');
    clone.setAttribute('aria-hidden', 'true');
    this.marquee.appendChild(clone);
    
    const trackWidth = this.track.offsetWidth;
    const gap = 14;
    const distance = trackWidth + gap;
    
    this.style.setProperty('--spt-distance', `${distance}px`);
    
    const duration = distance / 50;
    this.style.setProperty('--spt-duration', `${duration}s`);
    
    this.marquee.classList.add('is-ready');
  }

  initLiveCounter() {
    if (!this.liveNum) return;
    
    const baseCount = parseInt(this.liveNum.textContent.replace(/,/g, '')) || 14338;
    
    setInterval(() => {
      const variation = Math.floor(Math.random() * 10) - 5;
      const newCount = baseCount + variation;
      this.liveNum.textContent = newCount.toLocaleString();
    }, 3000);
  }
}

customElements.define('social-proof-ticker', SocialProofTicker);
